
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/chatbot",
      function () {
        return require("private-next-pages/[locale]/chatbot.tsx");
      }
    ]);
  